/**
 * @file       Component file for cypher web app
 * @version    2.0.0
 * @author     Mehran Majidi
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from '@app/service/theme.service';

@Component
({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
class AppComponent
{
    title = 'Cypher';

    /**
     * @desc   - construct the root app and apply stored theme
     * @access - public
     * @param  - themeService : light and dark color mode
     * @return -
     */
    constructor
    (
        private themeService: ThemeService
    )
    {
        this.themeService.applyStored();
    }
}

export { AppComponent }
